<template>
	<div
    v-show="visible"
    class="bg-white relative shadow-lg flex space-x-4 p-2 max-w-sm rounded-lg justify-start items-start relative pointer-events-auto"
    :class="{
        'border-l-4 border-red-500 border-t-0': type === 'error',
        'border-l-4 border-green-500 border-t-0': type === 'success',
        'border-l-4 border-yellow-500 border-t-0': type === 'warning',
        'border-l-4 border-blue-500 border-t-0': type === 'info',
        'pb-12': buttons
    }">

    <span class="p-2 w-10 h-10 flex justify-center items-center bg-green-300 rounded-full flex-shrink-0 bg-opacity-50" v-if="type === 'success'">
      <a-icon name="star" class="text-green-500 h-5 w-5" />
    </span>

    <span class="p-2 w-10 h-10 flex justify-center items-center bg-yellow-300 rounded-full flex-shrink-0 bg-opacity-50" v-if="type === 'warning'">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-yellow-600">
        <path d="M12 7.75V13" class="stroke-current" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21.08 8.58003V15.42C21.08 16.54 20.48 17.58 19.51 18.15L13.57 21.58C12.6 22.14 11.4 22.14 10.42 21.58L4.47998 18.15C3.50998 17.59 2.90997 16.55 2.90997 15.42V8.58003C2.90997 7.46003 3.50998 6.41999 4.47998 5.84999L10.42 2.42C11.39 1.86 12.59 1.86 13.57 2.42L19.51 5.84999C20.48 6.41999 21.08 7.45003 21.08 8.58003Z" class="stroke-current" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 16.2V16.2999" class="stroke-current" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>

    <span class="p-2 w-10 h-10 flex justify-center items-center bg-red-300 rounded-full flex-shrink-0 bg-opacity-50" v-if="type === 'error'">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-red-500">
        <path d="M12.0091 22.7401C11.3791 22.7401 10.7591 22.5301 10.2691 22.1101L8.68914 20.7601C8.52914 20.6201 8.12914 20.4801 7.91914 20.4801H6.16914C4.68914 20.4801 3.48914 19.2801 3.48914 17.8001V16.0901C3.48914 15.8801 3.34914 15.4801 3.21914 15.3301L1.85914 13.7301C1.03914 12.7601 1.03914 11.2401 1.85914 10.2601L3.21914 8.66007C3.34914 8.51007 3.48914 8.11007 3.48914 7.90007V6.20007C3.48914 4.72007 4.68914 3.52007 6.16914 3.52007H7.89914C8.10914 3.52007 8.49914 3.37007 8.66914 3.23007L10.2491 1.88007C11.2291 1.05007 12.7591 1.05007 13.7391 1.88007L15.3191 3.23007C15.4791 3.37007 15.8891 3.51007 16.0991 3.51007H17.7991C19.2791 3.51007 20.4791 4.71007 20.4791 6.19007V7.89007C20.4791 8.10007 20.6291 8.49007 20.7691 8.66007L22.1191 10.2401C22.9591 11.2301 22.9491 12.7601 22.1191 13.7301L20.7691 15.3101C20.6291 15.4801 20.4891 15.8701 20.4891 16.0801V17.7801C20.4891 19.2601 19.2891 20.4601 17.8091 20.4601H16.1091C15.8991 20.4601 15.5091 20.6101 15.3291 20.7501L13.7491 22.1001C13.2591 22.5301 12.6291 22.7401 12.0091 22.7401ZM6.16914 5.02007C5.51914 5.02007 4.98914 5.55007 4.98914 6.20007V7.90007C4.98914 8.47007 4.72914 9.19007 4.35914 9.63007L2.99914 11.2301C2.65914 11.6401 2.65914 12.3601 2.99914 12.7601L4.34914 14.3501C4.70914 14.7601 4.97914 15.5101 4.97914 16.0801V17.7901C4.97914 18.4401 5.50914 18.9701 6.15914 18.9701H7.89914C8.45914 18.9701 9.19914 19.2401 9.63914 19.6101L11.2291 20.9701C11.6391 21.3201 12.3591 21.3201 12.7691 20.9701L14.3491 19.6201C14.7991 19.2401 15.5291 18.9801 16.0891 18.9801H17.7891C18.4391 18.9801 18.9691 18.4501 18.9691 17.8001V16.1001C18.9691 15.5401 19.2391 14.8101 19.6091 14.3601L20.9691 12.7701C21.3191 12.3601 21.3191 11.6401 20.9691 11.2301L19.6191 9.65007C19.2391 9.20007 18.9791 8.47007 18.9791 7.91007V6.20007C18.9791 5.55007 18.4491 5.02007 17.7991 5.02007H16.0991C15.5291 5.02007 14.7891 4.75007 14.3491 4.38007L12.7591 3.02007C12.3491 2.67007 11.6391 2.67007 11.2191 3.02007L9.64914 4.38007C9.19914 4.75007 8.46914 5.02007 7.89914 5.02007H6.16914Z" class="fill-current"/>
        <path d="M12 16.8701C11.45 16.8701 11 16.4201 11 15.8701C11 15.3201 11.44 14.8701 12 14.8701C12.55 14.8701 13 15.3201 13 15.8701C13 16.4201 12.56 16.8701 12 16.8701Z" class="fill-current"/>
        <path d="M12 13.7199C11.59 13.7199 11.25 13.3799 11.25 12.9699V8.12988C11.25 7.71988 11.59 7.37988 12 7.37988C12.41 7.37988 12.75 7.71988 12.75 8.12988V12.9599C12.75 13.3799 12.42 13.7199 12 13.7199Z" class="fill-current"/>
      </svg>
    </span>

		<div class="flex flex-col flex-grow justify-start">
      <div class="flex items-start">
        <div class="text flex-grow" v-if="title || $slots.title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <button class="p-1 focus:outline-none" v-if="closable" @click="handleClose">
          <svg viewBox="0 0 35 35" width="25" height="25" fill="currentColor">
            <path d="M19.5,17.5l5.1,5.1l-2,2l-5.1-5.1l-5.1,5.1l-2-2l5.1-5.1l-5.1-5.1l2-2l5.1,5.1l5.1-5.1l2,2L19.5,17.5z"></path>
          </svg>
        </button>
      </div>
      <div class="pr-16">
        <template v-if="supportHTML">
          <div class="text-gray-500 text-sm" v-if="!collapsed" v-html="content">
            <slot></slot>
          </div>
        </template>
        <template v-else>
          <div class="text-gray-500 text-sm" v-if="!collapsed">
            <slot>
              {{ content }}
            </slot>
          </div>
        </template>
      </div>

      <div class="flex flex-col space-y-2" v-if="isSecure">
        <h2 class="text-gray-600 inline">
          Para proceder, por favor ingresa el texto a continuación: <br>
          <span class="text-gray-800 mt-2 text-md inline">{{ randomPassword }}</span>
        </h2>
        <a-input v-model="password" />
        <button @click="onConfirm(closeHandler)" class="w-full py-2 focus:outline-none hover:bg-gray-100 disabled:text-gray-400 rounded-md disabled:bg-gray-100" :disabled="randomPassword !== password">
          Confirmar
        </button>
      </div>

      <div class="flex mt-2 rounded-b-lg overflow-hidden absolute inset-x-0 bottom-0" v-if="hasButtons">
        <button
            v-for="(button, key) in buttons({ close: closeHandler })"
            :key="key"
            class="flex-grow py-2 text-sm focus:outline-none hover:bg-gray-100"
            @click="button.action">
          {{ button.title }}
        </button>
      </div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'm-message',
  props: {
    closable: { required: false, type: Boolean, default: false },
    type: { required: false, type: String, default: null },
    closeHandler: { required: true, type: Function },
    title: { required: true, type: String },
    content: { required: true, type: String },
    supportHTML: { required: true, type: Boolean },
    isCollapsed: { required: false, type: Boolean, default: true },
    buttons: { required: false, type: Function, default: null },
    isSecure: { required: false, type: Boolean, default: false },
    onConfirm: { required: false, type: Function, default: () => {} }
  },
  data() {
    return {
      visible: true,
      collapsed: this.isCollapsed,
      randomPassword: '',
      password: ''
    }
  },
  computed: {
    hasButtons() {
      return this.buttons !== null && typeof this.buttons === 'function'
    }
  },
  methods: {
    generateRandomPassword () {
      let result = '';
      let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let charactersLength = characters.length;

      for (let i = 0; i < 12; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      this.randomPassword = result
    },
    close () {
      this.visible = false
    },
    handleClose () {
      if (typeof this.closeHandler === 'function') this.closeHandler(this.close)
      else this.close()
    }
  },
  mounted () {
    if (this.isSecure) {
      this.generateRandomPassword()
    }
  }
}
</script>
